import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import { LoginPage } from './pages/LoginPage';
import { UsersPage } from './pages/UsersPage';
import { FamilyTreePage } from './pages/FamilyTreePage';
import { FamilyNamesPage } from './pages/FamilyNamesPage';
import { DataImportExportPage } from './pages/DataImportExportPage';
import { ProfilePage } from './pages/ProfilePage';
import { ProtectedRoute } from './components/ProtectedRoute';

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated ? <Navigate to="/family-tree" replace /> : <LoginPage />
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <UsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/family-tree"
        element={
          <ProtectedRoute>
            <FamilyTreePage />
          </ProtectedRoute>
        }
      />
      <Route path="/family-tree/share" element={<FamilyTreePage />} />
      <Route
        path="/family-names"
        element={
          <ProtectedRoute allowedRoles={['systemAdmin']}>
            <FamilyNamesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/data-import-export"
        element={
          <ProtectedRoute allowedRoles={['systemAdmin']}>
            <DataImportExportPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <SidebarProvider>
          <AppRoutes />
        </SidebarProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
